import { Box, Button, Card, CardActions, CssBaseline, Divider, Grid, Paper, Stack, Toolbar, Typography, useTheme } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import TwoHeadTable from '../../../../../../../components/TwoHeadTable'
import { PvMonitoringContext } from '../../../../../../../context/PvMonitoringContext'
import { WEB_KEY } from '../../../../../../../api/AxiosApi'
import AppModal from '../../../../../../../components/AppModal'
import PvViewMoreTable from '../../../../../../../components/pv_monitoring/PvViewMoreTable'
import PvAppModal from '../../../../../../../components/PvAppModal'
import { getDateTimeForPvParameter, getFormattedDateTime,getFormattedStaticDateTime } from '../../../../../../../utils'
let TableHead

function PvParameterTabContent({ ID, TabTitle }) {
    const { getPvMnPostString, getPvMnViewMorePostString, PvMnViewMorePostStringData, PvMnPostStringData, PvMnPostStringLoading } = useContext(PvMonitoringContext)
    const { spacing } = useTheme()
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const LOGIN_ID = localStorage.getItem('LoginID')
    const LOC_CODE = localStorage.getItem('LCODE')

    const [currentDateTime, setCurrentDateTime] = useState(getFormattedDateTime());


    // const [previousDateTime, setPreviousDateTime] = useState(getFormattedDateTime(-7));
    const [previousDateTime, setPreviousDateTime] = useState(getFormattedStaticDateTime());

    const handleCurrentDateTimeChange = (e) => {
        setCurrentDateTime(e.target.value);
    };

    const handlePreviousDateTimeChange = (e) => {
        setPreviousDateTime(e.target.value);
    };


    // const DT1 = "01-DEC-2023 00:00:00"
    // const DT2 = "10-DEC-2023 00:00:00"
    const ROW = 1
    const ROW2 = 0
    const PASS_KEY = "WERRRRRRRRRRR"



    useEffect(() => {
        getPvMnPostString(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, ID, previousDateTime, currentDateTime, ROW)
    }, [ID])

    function onViewMoreHandler() {
        handleOpen()
        getPvMnViewMorePostString(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, ID, previousDateTime, currentDateTime, ROW2)
    }

    function onRefreshPvParameter() {
        getPvMnViewMorePostString(LOGIN_ID, LOC_CODE, PASS_KEY, WEB_KEY, ID, previousDateTime, currentDateTime, ROW2)
    }

    if (PvMnViewMorePostStringData[0]) {
        TableHead = Object.keys(PvMnViewMorePostStringData[0])
    }


    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>

                {
                    PvMnPostStringData.length > 0 ?
                        <>
                            <Grid container spacing={spacing(1)} flexGrow={1}>
                                {
                                    PvMnPostStringData?.map((item, index) => {
                                        const [key, value] = item.split(' : ');
                                        return (

                                            <>
                                           {/* <h2>pv monitoring </h2> */}
                                            <Grid key={index} item xs={2}>
                                                <Card sx={{ ":hover": { backgroundColor: 'primary.main' } }}>
                                                    <CardActions>
                                                        <Typography variant='body1'>{key} : <Divider sx={{ mx: 10 }} /> </Typography>
                                                        <Typography variant='body1'>{value}</Typography>
                                                    </CardActions>
                                                </Card>
                                            </Grid>
                                            </>
                                        );
                                    })

                                }

                            </Grid>
                            <Typography component={Button} sx={{ display: 'flex', margin: 'auto' }} variant='body2' textAlign={'center'} onClick={onViewMoreHandler}>View More</Typography>
                        </>

                        : <Typography variant='body2' textAlign={'center'}>Data Loading......... </Typography>

                }


                <PvAppModal open={open} handleClose={handleClose}>
                    <Toolbar />

                    {/* <Typography variant='h5' my={3} textAlign={'center'}>{TabTitle}</Typography> */}
                    <PvViewMoreTable
                        TableName={TabTitle}
                        ValueOf1={previousDateTime}
                        ValueOf2={currentDateTime}
                        onChangeValueOF1={handlePreviousDateTimeChange}
                        onChangeValueOF2={handleCurrentDateTimeChange}
                        onRefreshData={onRefreshPvParameter}
                        TableHead={TableHead}
                        TableData={PvMnViewMorePostStringData}
                        onFullScreen={handleClose}
                        onHandleClose={handleClose}
                    />
                </PvAppModal>



            </Box>
        </>
    )
}

export default PvParameterTabContent

